export const tagDataFormat = (data: any, language) => {
    const datas = data?.rows?.map((item) => {
        const currentLanguaData = item.data.filter((val) => val.language.lang_code === language);
        return(
            {
                "icon": item.icon,
                "id": item.id,
                "short_code": item.short_code,
                "is_active":  item.is_active,
                "title": currentLanguaData[0]?.title,
                "content": currentLanguaData[0]?.text,
                "createdAt": item.createdAt,
                "updatedAt": item.updatedAt,
            }
        )
    })
    const infoTagData = {
        ...data,
        rows: datas,
      }
      
    return infoTagData;
}